<template>
  <div class="profileheader" v-bind:class="{flat: userDetails.flat, adultPicture: userDetails.pictureAdult}" style="width:100%;" v-bind:style="userDetails.profileHeaderStyling">
    <div v-if="usage == 'admin'" class="pageViewsContainer" style="z-index:5">
      <md-icon v-if="userDetails.warning" style="color:red">warning</md-icon>
      <md-icon style="color:white">remove_red_eye</md-icon>
      <span class="pageViews">  {{ userDetails.pageViews | numeral('[0].[0(0)]a') }}</span>
      <md-icon v-if="userDetails.autopilot && userDetails.autopilotURL" style="color:white">directions</md-icon>
    </div>
    
    <!-- <a v-if="userDetails.parentProfileLogo" v-bind:href="userDetails.parentFooterURL" target="_blank" style="display:flex; width: 100%; z-index: 1;"> -->
      <img v-if="userDetails.parentProfileLogo" :src="userDetails.parentProfileLogo" style="z-index: 1; width: 96px; filter: drop-shadow(rgb(234, 234, 234) 2px 2px 4px); position: absolute; top: 0px; left: 0px;z-index:1" v-bind:style="[userDetails.parentProfileLogoStyling]"/>
    <!-- </a> -->

    <!-- <md-button class="md-icon-button md-dense"  v-if="(account == 7 || enableUpgrades) && userDetails.verified" v-on:click="$refs.snackbar.open();" style="border: 1px solid rgb(192,192,192, 0.25); min-width:unset; min-height:unset; height:24px; width:24px; background: rgb(255,255,255,0.99);z-index: 5; top: 5px; left: calc(100% - 30px); margin:unset; color: rgb(56, 151, 240); position: absolute;">
      <md-icon style="font-size: 20px; left: 0px; top: 3px;">verified</md-icon>
    </md-button> -->
    <div v-if="(account == 7 || enableUpgrades) && userDetails.verified" v-on:click="$refs.snackbar.open();" style="border-radius:100%;fill: rgb(29, 155, 240); width:24px; background: #ffffff;z-index: 5; top: 5px; left: calc(100% - 30px); margin:unset; position: absolute;">
      <svg viewBox="0 0 22 22" aria-label="Verified account"><g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g></svg>
    </div>

    <div v-if="altProfile == 0 || isNaN(altProfile)" class="altProfile0" style="overflow:hidden; background:white; background-size:cover; background-position: center;  filter: blur(0px);" v-bind:style="{ backgroundImage: 'url(\'' + getUserPicture + '\')' }">
      <div style="overflow:hidden; height:175px; backdrop-filter:blur(10px);background: linear-gradient(180deg,hsla(0,0%,100%,0) 10%,rgba(0,0,0,.1));">
        <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="margin-top:15px; position: absolute; left: calc(50% - 54.5px);">
          <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="height:105px; width:105px; position:relative; display:block; margin-left:auto; margin-right:auto; min-width: 105px; min-height: 105px;max-width: 105px; max-height: 105px;" >
        </div>
        <div v-if="nameHide != true" class="md-title"  style="text-align:center; color:white;font-size:24px; margin-top:130px; text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);">{{ userDetails.name }}</div>
      </div>
      <div v-if="userDetails.bio" class="md-list-text-container" style="background:white;padding:10px 8px; padding-top:10px; padding-bottom:10px; text-align:center; font-weight:bold; white-space: pre-wrap; " v-html="bio"></div>
      <!-- <md-list-item v-if="bio" disabled style="margin:0px;width:100%;max-width:100%;background:white">
        <md-avatar v-bind:class="{'md-large': !userDetails.compactLinks, 'compactLinkMargin': userDetails.compactLinks }" style="background:white; border:1px solid silver;justify-content: center; display: flex; padding-top: 16px;">
          <i class="fa fa-fw fa-id-card-o" v-bind:class="{'fa-lg': userDetails.compactLinks,'fa-2x': !userDetails.compactLinks}" aria-hidden="true"></i>
        </md-avatar>
        <div class="md-list-text-container" style="background:unset;padding-top:10px; padding-bottom:10px">
          <span style="font-weight:bold; white-space: pre-wrap; ">{{bio}}</span>
        </div>
      </md-list-item> -->
    </div>

    <div v-else-if="(altProfile == 1 || altProfile == 6)" style="position:relative;" v-bind:style="{background: userDetails.headerColor}" v-bind:class="'altProfile' + userDetails.altProfile">
      <div v-if="altProfile == 1" v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}">
        <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(textColour(userDetails.headerColor))}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="min-width: 80px; min-height: 80px;max-width: 80px; max-height: 80px;" >
      </div>
      <div class="textbox">
        <div class="name" v-bind:style="{color: textColour(userDetails.headerColor)}">{{userDetails.name}}</div>
        <div class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" v-html="bio"></div>
      </div>
      <div v-if="altProfile == 6" v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="">
        <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="width:80px; height:80px; object-fit:cover; object-position:center; min-width: 80px; min-height: 80px;max-width: 80px; max-height: 80px;" >
      </div>
    </div>

    <!-- <div v-else-if="isAltProfileAllowed(7) == 2 || isAltProfileAllowed(7) == 3 || isAltProfileAllowed(7) == 11 || isAltProfileAllowed(7) == 9" disabled class="profileAlt2" style="background:white; padding:unset;margin-right:0px; margin-left:0px; display: block; width:100%;max-width:100%; overflow:hidden; position:relative"> -->
    <div v-else-if="(altProfile == 2 || altProfile == 3 || altProfile == 11 || altProfile == 9 || altProfile == 19)" disabled class="profileAlt2" style="padding:unset;margin-right:0px; margin-left:0px; display: block; width:100%;max-width:100%; overflow:hidden; position:relative" v-bind:class="{ aspectRatio1x1 : altProfile == 2, aspectRatio4x3: altProfile == 3, aspectRatio16x9: altProfile == 11, aspectRatio3x4: altProfile == 9, aspectRatio9x16: altProfile == 19}" v-bind:style="{'padding-top': profileHeaderPadding}">
      <!-- <div style="width:100%;" > -->
        <img id="profilePicAlt2" alt="" v-bind:src=getUserPicture style="object-fit:cover; object-position:center;position: absolute;top: 0px;left: 0px;height:100%;width:100%" v-bind:style="[userDetails.pictureStyling]">
        <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="background: rgb(255,255,255);
            background: linear-gradient(180deg, rgba(255,255,255,0) 50%, rgba(0,0,0,.25) 100%);position: absolute;
            top: 0px; left: 0px; height: 100%; width: 100%;display: flex;flex-direction: column;justify-content: end; padding: 10px; gap: 5px;">
          
          <div class="md-title" style="font-size:24px; width:auto; text-align:center; color:white; font-weight:bold" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="text-align:center;line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;" v-html="bio"></div>
            <div v-if="userDetails.business != undefined" style="justify-content: center; display: flex;">
              <md-button v-for="(link, index) in userDetails.business.links" class="md-icon-button" v-bind:key="index" v-if="userDetails.business.links && link.enabled != false"  style="color:#ffffff" v-bind:class="{profilepulse: link.pulse}" @click="profileLinksClicked(index, link.target, 'custom', link.label)">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon" v-bind:style="link.style"></md-icon>
  <img v-else style="height:24px; width:24px; margin-bottom:5px;filter: drop-shadow(rgb(0, 0, 0) 0px 1px 0px);" :src="link.icon" />

</md-button>
            </div>
          
          <div style="width: 100%; position: absolute;height: auto;bottom: 10px;">
            
          </div>
          
        </div>
        
      <!-- </div> -->
    </div>

    <div v-else-if="altProfile == 4 || altProfile == 7" v-bind:style="{background: userDetails.headerColor}" style="background:white;">
      <div v-if="nameHide != true" class="name" v-bind:style="{background: userDetails.headerColor, color: textColour(userDetails.headerColor)}" style="text-align:center; padding:10px; text-transform: uppercase;font-weight: bold; font-size: x-large;">{{userDetails.name}}</div>
      <img class="avatar" v-bind:class="{ aspectRatio1x1 : altProfile == 7, aspectRatio16x9: altProfile == 4}" v-bind:src=getUserPicture style="background:white; height: 100%; width:100%; object-fit: cover; object-position: center;" />
      <div v-if="bio" class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="text-align:center; font-size:16px; padding:10px 20px" v-html="bio"></div>
    </div>

    <div v-else-if="altProfile == 15" v-bind:style="{background: userDetails.headerColor}" style="background:white;">
      <!-- <div v-if="nameHide != true" class="name" v-bind:style="{background: userDetails.headerColor, color: textColour(userDetails.headerColor)}" style="text-align:center; padding:10px; text-transform: uppercase;font-weight: bold; font-size: x-large;">{{userDetails.name}}</div> -->
      <div>
      <img class="avatar" v-bind:class="{ aspectRatio16x91 : true}" v-bind:src="userDetails.headerImage" style="aspect-ratio:3/1;background:white; height: 100%; width:100%; object-fit: cover; object-position: center;" />
      <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="top: 60px; position: absolute;
    left: calc(50% - 54.5px); background:silver !important;">
          <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="height:105px; width:105px; position:relative; display:block; margin-left:auto; margin-right:auto; min-width: 105px; min-height: 105px;max-width: 105px; max-height: 105px;" >
        </div>
      </div>
      <div style="overflow:hidden; background:white">
        
        <div v-if="nameHide != true" class="md-title"  style="text-align:center; font-weight:bold; color:black;font-size:24px; padding: 40px 0px 10px 0px;">{{ userDetails.name }}</div>
      <div v-if="bio" class="bio" style=" color:black; text-align:center; font-size:16px; padding:0px 20px 10px" v-html="bio"></div>

      </div>
    </div>

    <div v-else-if="altProfile == 16" style="position:relative">
          <img v-bind:src="getUserPicture" v-bind:class="{}" style="aspect-ratio:3/4; width:100%; object-fit: cover;
    object-position: center;" >
        <div style="overflow: hidden; color:#ffffff;
    background: #00000017;
    position: absolute;
    bottom: 0px;
    width: 100%;
    backdrop-filter: blur(2px);
    border-top: 1px solid silver;padding: 10px;display:flex; flex-direction:column;gap:10px;align-items:center; text-shadow: 0 1px 0 black;">
        
        <div v-if="nameHide != true" class="md-title"  style="text-transform:uppercase; letter-spacing: 5px; font-weight:bold; font-size:24px; ">{{ userDetails.name }}</div>
      <div v-if="bio" class="bio" style="font-size:16px; text-align:center" v-html="bio"></div>
      <div v-if="userDetails.business != undefined"><md-button v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" :href="link.target" v-bind:key="index" target="_blank" class="md-icon-button" style="border-radius:5px">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
  <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />

</md-button></div>
      </div>
      
      
    </div>

    <div v-else-if="altProfile == 17" style="position:relative">
          <img v-bind:src="getUserPicture" v-bind:class="{}" style="aspect-ratio:1/1; width:100%; object-fit: cover;
    object-position: center;" v-bind:style="[userDetails.pictureStyling]">
        <div style="overflow: hidden; color:#ffffff;
    background: #00000017;
    position: absolute;
    bottom: 0px;
    width: 100%;
    backdrop-filter: blur(2px);
    border-top: 1px solid silver;padding: 10px;display:flex; flex-direction:column;gap:10px;align-items:center; text-shadow: 0 1px 0 black;">
        
        <div v-if="nameHide != true" class="md-title"  style="text-transform:uppercase; letter-spacing: 5px; font-weight:bold; font-size:24px; " v-bind:style="[userDetails.profileStyling]">{{ userDetails.name }}</div>
      <div v-if="bio" class="bio" style="font-size:16px; text-align:center" v-html="bio"></div>
      <div v-if="userDetails.business != undefined"><md-button v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" :href="link.target" v-bind:key="index" target="_blank" class="md-icon-button" style="border-radius:5px">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
  <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />

</md-button></div>
      </div>
      
    </div>

    <div v-else-if="altProfile == 18 || altProfile == 23 || altProfile == 30" style="overflow: hidden;" v-bind:class="{aspectRatio9x16: altProfile == 18,  aspectRatio3x4: altProfile == 23, aspectRatio1x1: altProfile == 30}">
          <img v-bind:src="getUserPicture" v-bind:class="{aspectRatio9x16: altProfile == 18,  aspectRatio3x4: altProfile == 23, aspectRatio1x1: altProfile == 30}" style="width:100%; object-fit: cover;
    object-position: center;" v-bind:style="[userDetails.pictureStyling]">
    <!-- <a v-bind:href="userDetails.parentFooterURL" target="_blank">
    <img v-if="userDetails.parentProfileLogo" :src="userDetails.parentProfileLogo" style="width: 96px;
    filter: drop-shadow(rgb(234, 234, 234) 2px 2px 4px);
    position: absolute;
    top: 0px;
    left: 0px;" v-bind:style="[userDetails.parentProfileLogoStyling]"/>
    </a> -->
        <div style="overflow: hidden; color:#ffffff;
        border-radius: 0 0 10px 10px;
    background: #00000017;
    position: sticky;
    bottom: 0px;
    width: 100%;
    backdrop-filter: blur(2px);
    border-top: 1px solid silver;padding: 10px;display:flex; flex-direction:column;gap:10px;align-items:center; text-shadow: 0 1px 0 black;" v-bind:style="userDetails.profileStyling">
        
        <div v-if="nameHide != true" class="md-title"  style="text-transform:uppercase; letter-spacing: 3px; text-align:center; font-weight:bold; font-size:24px; " v-html="userDetails.name"></div>
      <div v-if="bio" class="bio18" style="font-size:16px; text-align:center" v-html="bio"></div>

      <div v-if="userDetails.business != undefined">
        <md-button v-for="(link, index) in userDetails.business.links" class="md-icon-button" v-bind:key="index" v-if="userDetails.business.links && link.enabled != false"  v-bind:class="{profilepulse: link.pulse}" @click="profileLinksClicked(index, link.target, 'custom', link.label)">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon" v-bind:style="link.style"></md-icon>
  <img v-else style="height:24px; width:24px; margin-bottom:5px;filter: drop-shadow(rgb(0, 0, 0) 0px 1px 0px);" :src="link.icon" />

</md-button></div>
      </div>
      
    </div>


    <!-- <div v-else-if="altProfile == 5 || altProfile == 14" class="noborder" style="background:silver; min-height:175px;margin-top:15px; margin-bottom: 15px !important;"> 
      <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle', avatar2x: altProfile == 14}" style="position: absolute;
    left: calc(50% - 54.5px);display:block; margin-right:auto; margin-left:auto;background: none; width:105px">
        <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="width:105px; height:105px;aspect-ratio: 1/1;
    object-fit: cover;
    object-position: center;" >
      </div>
      <div style="margin-top:130px">
      <div v-if="nameHide != true" class="md-title"  style="font-weight:bold;text-align:center; color:#ffffff;font-size:24px; margin-top:25px; text-shadow: 1px 1px 3px rgba(0, 0, 0, 1);" v-html="userDetails.name">{{ userDetails.name }}</div>
        <div v-if="bio" class="bio" style="text-align:center; color:#ffffff; font-size:16px; padding:10px 20px; text-shadow: 1px 1px 3px rgba(0, 0, 0, 1);"  v-html="bio"></div>
      </div>
    </div> -->


    <div v-else-if="altProfile == 5" class="noborder" style="display:grid; min-height:150px;margin-top:15px; margin-bottom: 15px !important;" v-bind:style="userDetails.profileStyling"> 
      <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle', avatar2x: altProfile == 14}" style="position: absolute;
    left: calc(50% - 54.5px);display:block; margin-right:auto; margin-left:auto;background: none;">
        <img v-bind:src="getUserPicture" v-bind:style="[{border: setAvatarBorder(textColour(userDetails.background))}, userDetails.imageStyling]" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="width:105px; height:105px;aspect-ratio: 1/1;
    object-fit: cover;
    object-position: center;" >
      </div>
      <div style="margin-top:120px" v-bind:style="{color:textColour(userDetails.background)}">
        <div v-if="nameHide != true" class="md-title"  style="font-weight:bold;text-align:center;font-size:24px; margin-top:25px;" v-bind:style="userDetails.profileStyling" v-html="userDetails.name"></div>
        <div v-if="bio" class="bio" v-bind:style="userDetails.profileStyling" style="text-align:center; font-size:16px; padding:10px 20px;"  v-html="bio"></div>
      

 <div v-if="userDetails.business != undefined" style="padding-top: 20px;
    justify-content: center;
    display: flex;">
        <md-button v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" :href="link.target" v-bind:key="index" target="_blank" class="md-icon-button">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
  <img v-else style="height:24px; width:24px; margin-bottom:5px" :src="link.icon" />

</md-button></div>



      </div>
      
    </div>

  <div v-else-if="altProfile == 14" class="noborder" style="width:100%'; display:grid; min-height:175px;margin-top:15px; margin-bottom: 15px !important;"> 
      <!-- <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="width:80%; margin-right:auto; margin-left:auto;background: none;"> -->
        <img v-bind:src="getUserPicture" style="width:100%;
    object-fit: cover;
    object-position: center;
    aspect-ratio:4/3" >
      <!-- </div> -->
      <!-- <div v-bind:style="{color:textColour(userDetails.background)}" style="padding-top:10px"> -->
        <!-- <div v-if="nameHide != true" class="md-title"  style="font-weight:bold;text-align:center;font-size:24px; " v-html="userDetails.name">{{ userDetails.name }}</div> -->
        <!-- <div v-if="bio" class="bio" style="text-align:center; font-size:16px; padding:10px 20px;"  v-html="bio"></div> -->
      <!-- </div> -->
    </div>



    <div v-else-if="altProfile == 8">
      <div class="" style="min-height: 120px;display: block;">
        <img v-bind:src="getUserPicture" v-bind:style="{borderWidth: '2px', borderColor: userDetails.headerColor, }" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="background: white; width:80px; height:80px; position: absolute; margin: 20px 16px;" />
        <div class="textbox username" style="width:100%; height:60px; padding-left: 112px; display:flex" v-bind:style="{background: userDetails.headerColor}">
          <div class="name" v-bind:style="{color: textColour(userDetails.headerColor)}" style="font-weight:bold; font-size:x-large; padding-bottom:12px; align-self:flex-end">{{userDetails.name}}</div>
        </div>
        <div class="textbox userbio" style="width:100%; min-height:60px; padding-left: 112px; display:flex; background:white">
          <div class="bio" style="padding: 8px 16px 8px 0;width:100%; color:black" v-html="bio"></div>
        </div>
      </div>
    </div>

    <div v-else-if="altProfile == 10" v-bind:style="{background: userDetails.headerColor}" style="display:flex; justify-content:start; width:100%; background:white;">
      <div style="width:33%">
        <img v-bind:src=getUserPicture style="object-position: center; object-fit: cover; height:200px; width:100% " />
      </div>
      <div style=" width:66%;position: absolute; right: 0; top: 0px;">
        <div v-if="nameHide != true" class="name" v-bind:style="{color: textColour(userDetails.headerColor)}" style="padding:10px; text-transform: uppercase;font-weight: bold; font-size: x-large;">{{userDetails.name}}</div>
        <div class="bio" style=";padding-left:10px; padding-top:8px; padding-bottom:8px; width:100%; color:black" v-bind:style="{color: textColour(userDetails.headerColor)}" v-html="bio"></div>
      </div>
    </div>

    <div v-else-if="altProfile == 12" v-bind:style="{background: userDetails.headerColor}" style="background:white;">
      <div>
        <img class="heroIamge" v-bind:src='userDetails.headerImage' style="width:100%; object-fit: cover; object-position: center;min-width: 100%; height: 115px; background: gainsboro;" />
        <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="position: absolute; top: 90px; left: 16px; width:80px; height: 80px;">
          <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="width:100%; aspect-ratio: 1/1;" >
        </div>
        <!-- <img v-bind:src=getUserPicture style="position: absolute; top: 90px; left: 16px; border: 1px solid white;width:80px; height: 80px;" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}"  /> -->
      </div>
      <div> 
        <div class="name" v-bind:style="{color: textColour(userDetails.headerColor)}" style="min-height:70px; padding: 16px 16px 16px 111px; color: rgb(0, 0, 0); font-weight: bold; font-size: large;  text-transform: uppercase;">
          <div>{{userDetails.name}}</div>
          <div v-if="bio" cla ss="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="font-weight:normal; font-size:small" v-html="bio"></div>
        </div>
      </div>
    </div>


    <div v-else-if="altProfile == 13" v-bind:style="{background: userDetails.headerColor}" style="align-items: center;padding:20px 30px;display: flex; flex-flow:column; gap:10px;"> 
      <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle', clearContainer: userDetails.pictureShape != 'squircle'}" style="left: calc(50% - 127px);display:block; top:30px;background: none; width:254px; height:254px" v-bind:style="{background: getClearContainer()}">
        <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="width:250px; height:250px;aspect-ratio: 1/1;
    object-fit: cover;
    object-position: center;" >
      </div>
      <div>
      <div v-if="nameHide != true" class="" v-bind:style="[userDetails.profileStyling, {color: textColour(userDetails.headerColor)}]" style="line-height: 30px;font-weight: bolder; font-size: x-large; text-transform: uppercase; letter-spacing: 5px; text-align: center;margin-left: 5px;">{{userDetails.name}}</div>

      <!-- <div v-if="nameHide != true" class="md-title" v-bind:style="{color: textColour(userDetails.headerColor)}"  style="line-height: 30px;margin-top:270px;font-weight: bolder; font-size: x-large; text-transform: uppercase; letter-spacing: 5px; text-align: center;" v-html="userDetails.name">{{ userDetails.name }}</div> -->
        <!-- <div v-if="bio" class="bio" style="text-align:center; color:#ffffff; font-size:16px; padding:10px 20px; text-shadow: 1px 1px 3px rgba(0, 0, 0, 1);"  v-html="bio"></div> -->
      <div class="" v-bind:style="[userDetails.profileStyling,{color: textColour(userDetails.headerColor)}]" style="width:100%; text-align:center" v-html="bio"></div>

      </div>
    </div>


    <div v-else-if="altProfile == 20" v-bind:style="{background: userDetails.headerColor}" class="businessProfile" style="">
      <img v-bind:src="getUserPicture" style="width:100%; aspect-ratio: 4/3;object-fit: cover; object-position: center;" v-bind:style=[userDetails.business.headerStyling]>
      <img v-if="userDetails.business.companyLogo" v-bind:src="userDetails.business.companyLogo" v-bind:class="{squareAvatar: userDetails.pictureShape == 'square'}" style="background:white; border:5px solid white; border-radius:100%; position: relative;
    bottom: 60px; margin-bottom:-100px;
    left: calc(100% - 116px);width:100px; aspect-ratio: 1/1;object-fit: cover; object-position: center;box-shadow: 0 1px 5px rgb(0 0 0 / 10%), 0 2px 2px rgb(0 0 0 / 7%), 0 3px 1px -2px rgb(0 0 0 / 6%);" >

      <div class="info" style="padding:0px 16px 6px;display: grid;gap:10px" :class="{'noLogo': !userDetails.business.companyLogo}">
        <div v-if="nameHide != true" class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="line-height: 30px;font-weight: bolder; font-size: x-large; text-transform: capitalize; letter-spacing: 1px; text-indent: 85px;
    direction: rtl;
    text-align: left;" v-html="userDetails.name"></div>
        <div v-if="userDetails.business.title" class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; "><md-icon style="width: 18px; min-width: 18px; height: 18px; min-height: 18px; font-size: 18px;vertical-align: text-bottom;; margin-right:10px">work_outline</md-icon>{{userDetails.business.title}}</div>
        <div v-if="userDetails.business.company" class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; "><md-icon style="width: 18px; min-width: 18px; height: 18px; min-height: 18px; font-size: 18px;vertical-align: text-bottom;; margin-right:10px">business</md-icon>{{userDetails.business.company}}</div>

      <div v-if="userDetails.business.location" class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%;display:flex; "><md-icon style="width: 18px;
    min-width: 18px;
    height: 18px;
    min-height: 18px;
    font-size: 18px;vertical-align: text-bottom;margin-left:0; margin-right:10px">location_on</md-icon><div>{{userDetails.business.location}}</div></div>

    <div v-if="userDetails.business.email" class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; "><md-icon style="width: 18px;
    min-width: 18px;
    height: 18px;
    min-height: 18px;
    font-size: 18px;vertical-align: text-bottom;; margin-right:10px">mail_outline</md-icon><a :href="'mailto:'+userDetails.email" style="color:unset">{{userDetails.business.email}}</a></div>

<div v-if="userDetails.business.phone"  class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; "><md-icon style="width: 18px;
    min-width: 18px;
    height: 18px;
    min-height: 18px;
    font-size: 18px;vertical-align: text-bottom; margin-right:10px">phone</md-icon><a :href="'tel:'+userDetails.business.phone" style="color:unset">{{userDetails.business.phone}}</a></div>

<div v-if="userDetails.business.bio"  class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; ">{{userDetails.bio}}</div>


<!-- <div class="" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; "><md-icon style="width: 18px;
    min-width: 18px;
    height: 18px;
    min-height: 18px;
    font-size: 18px;vertical-align: text-bottom; margin-right:5px">public</md-icon><a :href="'tel:'+userDetails.phone" style="color:unset">{{userDetails.phone}}</a></div> -->

<div v-if="userDetails.business.showLinks != false" class="businessLinks" style="width:100%; display:inline-flex; justify-content: space-between;">
  <!-- <div>
  <div v-if="usage == 'admin'" class="counter">20</div> -->
  <div v-if="userDetails.business.linkHome" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.linkHomeClicks != null" class="counter">{{userDetails.business.linkHomeClicks}}</div>
  <md-button @click="profileLinksClicked(index, userDetails.business.linkHome, 'linkHome')" class="link md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <md-icon>home</md-icon>
</md-button>
</div>
  <!-- </div> -->

<div v-if="userDetails.business.email" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.emailClicks != null" class="counter">{{userDetails.business.emailClicks}}</div>
  <md-button @click="profileLinksClicked(index, 'mailto:'+userDetails.business.email, 'email')"  class="md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <!-- <md-button v-if="userDetails.business.email" :href="'mailto:'+userDetails.business.email" target="_blank" class="md-icon-button md-raised"> -->
  <md-icon>mail_outline</md-icon>
</md-button>
</div>

<div v-if="userDetails.business.phone" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.phoneClicks != null" class="counter">{{userDetails.business.phoneClicks}}</div>
<md-button @click="profileLinksClicked(index, 'tel:'+userDetails.business.phone, 'phone')" class="md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
<!-- <md-button v-if="userDetails.business.phone" :href="'tel:'+userDetails.business.phone" target="_blank" class="md-icon-button md-raised"> -->
  <md-icon>phone</md-icon>
</md-button>
</div>

<div v-if="userDetails.business.linkLinkedin" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.linkLinkedinClicks != null" class="counter">{{userDetails.business.linkLinkedinClicks}}</div>
  <md-button class="md-icon-button md-raised" @click="profileLinksClicked(index, userDetails.business.linkLinkedin, 'linkLinkedin')" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <md-icon md-iconset="fa fa-linkedin"></md-icon>
</md-button>
</div>

  <md-button v-if="userDetails.business.linkDiscord" :href="userDetails.business.linkLinkedin" target="_blank" class="md-icon-button md-raised">
  <img style="height:18px; width:18px; margin-bottom:5px" src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/favicons%2Fdiscord.jpg?alt=media&token=f38b9991-2727-42d0-903b-8c64c2d8b7fd" />
</md-button>

<div v-if="userDetails.business.linkTwitter" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.linkTwitterClicks != null" class="counter">{{userDetails.business.linkTwitterClicks}}</div>
<md-button @click="profileLinksClicked(index, userDetails.business.linkTwitter, 'linkTwitter')" class="md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <md-icon md-iconset="fa fa-twitter"></md-icon>
</md-button>
</div>

<div v-if="userDetails.business.linkInstagram" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.linkInstagramClicks != null" class="counter">{{userDetails.business.linkInstagramClicks}}</div>
<md-button @click="profileLinksClicked(index, userDetails.business.linkInstagram, 'linkInstagram')" class="md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <md-icon md-iconset="fa fa-instagram"></md-icon>
</md-button>
</div>

<div v-if="userDetails.business.linkFacebook" style="position:relative">
  <div v-if="usage == 'admin' && userDetails.business.linkFacebookClicks != null" class="counter">{{userDetails.business.linkFacebookClicks}}</div>
<md-button @click="profileLinksClicked(index, userDetails.business.linkFacebook, 'linkFacebook')" class="md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <md-icon md-iconset="fa fa-facebook"></md-icon>
</md-button>
</div>

<md-button v-if="userDetails.business.linkTelegram" :href="userDetails.business.linkTelegram" target="_blank" class="md-icon-button md-raised" v-bind:style="{color: textColour(userDetails.headerColor)}">
  <md-icon md-iconset="fa fa-telegram"></md-icon>
</md-button>


<div v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="position:relative">
  <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
  <md-button class="md-icon-button md-raised" @click="profileLinksClicked(index, link.target, 'custom')" v-bind:style="{color: textColour(userDetails.headerColor)}">
   <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
  <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
</md-button>
  </div>


<!-- <md-button v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" :href="link.target" target="_blank" class="md-icon-button md-raised">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
  <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />

</md-button> -->

<md-button v-if="userDetails.business.download != false && userDetails.business.altDownload !== true" :href="userDetails.business.linkFacebook" target="_blank" class="md-icon-button md-raised" style="background:#0AD5A72b" @click="downloadvCard()">
  <md-icon style="color:darkgreen" v-bind:style="{color: textColour(userDetails.headerColor)}"  >person_add</md-icon>
</md-button>



<!-- <div></div> -->
      </div>
      <md-button v-if="userDetails.business.download != false && userDetails.business.altDownload === true" :href="userDetails.business.linkFacebook" target="_blank" class="md-raised" style="width:100%; margin:unset; border-radius:7px;" @click="downloadvCard()">
  download
</md-button>
      </div>



      <!-- <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle', clearContainer: userDetails.pictureShape != 'squircle'}" style="position: absolute;
    left: calc(50% - 127px);display:block; top:30px;background: none; width:254px; height:254px" v-bind:style="{background: getClearContainer()}">
      </div> -->
      <div>


      </div>
    </div>

    
    <div v-else-if="altProfile == 21" style="justify-content: center; display: grid; padding: 25px;">
      <!-- <svg viewBox="0 0 56 18">
  <text x="0" y="15">Fit Me</text>
</svg> -->
      <div v-if="nameHide != true" class="name" style="font-weight: bold;line-height: 30px;text-transform: uppercase; letter-spacing: 10px; margin-left:10px; text-align: center;" v-bind:style="[{ color: textColour(userDetails.background)},userDetails.profileStyling]" v-html="userDetails.name"></div>
      <!-- <div v-if="nameHide != true" class="name" v-bind:style="{color: textColour(userDetails.background)}" style="text-shadow: 2px 3px 2px #cccccc;line-height: 30px;font-weight: bolder; font-size: xxx-large; text-transform: uppercase; letter-spacing: 10px; margin-left:10px; text-align: center;" v-html="userDetails.name">{{}}</div> -->
      <div v-if="bio" class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="font-size: larger; font-weight: bold; padding-top:10px;width:100%; text-align:center" v-html="bio"></div>
    </div>

    <div v-else-if="altProfile == 131" v-bind:style="{background: userDetails.headerColor}" style="justify-content: center; display: grid; padding: 25px;border:1px solid whitesmoke">
      <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="background: none; width:254px; height:254px;left: calc(50% - 125px);position:absolute;     display: block; margin-right: auto; margin-left: auto;">
        <img v-bind:src="getUserPicture" v-bind:style="{borderWidth: '2px', background: textColour(userDetails.headerColor), borderColor: textColour(userDetails.headerColor), }" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="border-style:solid; border-width:2px; width:250px; height:250px" />
      </div>
      <div v-if="nameHide != true" class="name" v-bind:style="{color: textColour(userDetails.headerColor)}" style="line-height: 30px;margin-top:270px;font-weight: bolder; font-size: x-large; text-transform: uppercase; letter-spacing: 5px; text-align: center;">{{userDetails.name}}</div>
      <div class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; text-align:center" v-html="bio"></div>
    </div>

<div v-else-if="altProfile == 22" v-bind:style="{background: userDetails.headerColor}" style="background:white;">
      <div>
        <video :src="userDetails.headerImage" muted="muted" autoplay="autoplay" loop="loop" playsinline="" style="aspect-ratio:16/9"></video>
        <!-- <img class="heroIamge" v-bind:src='userDetails.headerImage' style="width:100%; object-fit: cover; object-position: center;min-width: 100%; height: 115px; background: gainsboro;" /> -->
        
        <!-- <img v-bind:src=getUserPicture style="position: absolute; top: 90px; left: 16px; border: 1px solid white;width:80px; height: 80px;" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}"  /> -->
      </div>
      <div> 
        <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="z-index:2; margin-bottom:-80px; position: relative; top: -40px; left: 16px; width:80px; height: 80px;">
          <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="width:100%; aspect-ratio: 1/1; background:white" >
        </div>
        <div class="name" v-bind:style="{color: textColour(userDetails.headerColor)}" style="min-height:70px; padding: 16px 16px 16px 111px; color: rgb(0, 0, 0); font-weight: bold; font-size: large;  text-transform: uppercase;">
          <div>{{userDetails.name}}</div>
          <div v-if="bio" cla ss="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="font-weight:normal; font-size:small" v-html="bio"></div>
        </div>
      </div>
    </div>

    <div v-else-if="altProfile == 24" style="justify-content: center; display: grid; padding: 25px 0px;">
      <!-- <svg viewBox="0 0 56 18">
  <text x="0" y="15">Fit Me</text>
</svg> -->
<img v-bind:src="getUserPicture" style="width:100%" v-bind:style="[userDetails.pictureStyling]" />
<div style="padding-top:20px; text-align: center; font-size: 20px; font-weight: bold;">{{ userDetails.bio }}</div>
      <!-- <div v-if="bio" class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; text-align:center" v-html="bio"></div> -->
    </div>

    <div v-else-if="altProfile == 25" style="justify-content: center;
    display: grid;
    padding: 25px 0px;
    box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);
    background: white;
    border-radius: 10px 10px 0 0;
    margin-top: 55px;min-height:200px;">
      <!-- <svg viewBox="0 0 56 18">
  <text x="0" y="15">Fit Me</text>
</svg> --><div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="top:-50px;position: relative;">
          <img v-bind:src="getUserPicture" v-bind:style="[userDetails.pictureStyling, {border: setAvatarBorder(userDetails.background)}]" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="height:105px; width:105px; position:relative; display:block; margin-left:auto; margin-right:auto; " >
        </div>

        <div v-if="nameHide != true" class="md-title"  style="text-align:center; color:white;font-size:24px;text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);">{{ userDetails.name }}</div>

      <!-- <div v-if="bio" class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; text-align:center" v-html="bio"></div> -->
    </div>

    <div v-else-if="altProfile == 26" disabled class="profileAlt2" style="padding:unset;margin-right:0px; margin-left:0px; display: block; width:100%;max-width:100%; overflow:hidden; position:relative">
      <div style="width:100%;" v-bind:class="{ aspectRatio1x1 : altProfile == 26}" v-bind:style="{'padding-top': profileHeaderPadding}">
        <img id="profilePicAlt2" alt="" v-bind:src=getRandomPicture style="object-fit:cover; object-position:center;position: absolute;top: 0px;left: 0px;height:100%;width:100%">
        <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="background: rgb(255,255,255);
            background: linear-gradient(180deg, rgba(255,255,255,0) 50%, rgba(0,0,0,.25) 100%);position: absolute;
            top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;">
          <div style="width: 100%; position: absolute;height: auto;bottom: 0px;">
            <div class="md-title" style="font-size:24px; margin:10px; width:auto; text-align:center; color:white; font-weight:bold">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="margin:10px 20px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;" v-html="bio"></div>
          </div>
        </div>
      </div>
    </div>


    <div v-else-if="(altProfile == 27)" disabled style="margin-left:auto; margin-right:auto; text-align:center;" v-bind:style="{background: userDetails.headerColor}">
        <img v-bind:src=getUserPicture style="padding:25px;" v-bind:style="userDetails.pictureStyling">
        <div v-if="bio && bio != '<blank>'" style="padding:0px 20px 10px 20px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;" v-bind:style="{color: textColour(userDetails.headerColor)}" v-html="bio"></div>

    </div>
    <div v-else-if="(altProfile == 28)" disabled style="position:relative; display:flex; flex-direction:column">
        <img v-bind:src=getUserPicture>
<div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="background: rgb(255,255,255);
            background: linear-gradient(180deg, rgba(255,255,255,0) 50%, rgba(0,0,0,.25) 100%);height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;">
          <div style="width: 100%; height: auto;">
            <div class="md-title" style="font-size:24px; margin:10px; width:auto; text-align:center; color:white; font-weight:bold">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="margin:10px 20px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;" v-html="bio"></div>
          </div>
        </div>
        <div v-if="userDetails.business && userDetails.business.links" style="position:absolute; top:0px; left:0;display: flex;" v-bind:style="userDetails.profileStyling">
        <div v-for="(link, index) in userDetails.business.links" v-bind:key="index" style=" align-items: flex-start;display:flex;justify-content: center;padding-bottom:5px" v-bind:style="userDetails.profileStyling">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
          <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')" style="margin:unset; color:#000000; border-radius:10px;">
            <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
            <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" v-bind:style="link.style"/>
          </md-button>

  </div>
  <!-- <md-button v-if="userDetails.business.download != false" :href="userDetails.business.linkFacebook" target="_blank" class="md-icon-button md-raised" @click="downloadvCard()">
  <md-icon style="color:#ffffff">person_add</md-icon>
</md-button> -->

<!-- <md-button v-if="userDetails.business.qrcode != false" class="md-icon-button md-raised" @click="openDialog('qrcodeDialog')">
    <md-icon style="color:#ffffff">qr_code</md-icon>
  </md-button> -->
  </div>
    </div>
    <div v-else-if="(altProfile == '27a')" disabled style="padding:unset;margin-right:0px; margin-left:0px; display: block; width:100%;max-width:100%; overflow:hidden; position:relative" v-bind:style="{background: userDetails.headerColor}">
      <div style="width:100%;">
        <img id="profilePicAlt2" alt="" v-bind:src=getUserPicture style="object-fit:cover; object-position:center;position: absolute;top: 0px;left: 0px;padding:20px;width:100%">
        <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="background: rgb(255,255,255);
            background: linear-gradient(180deg, rgba(255,255,255,0) 50%, rgba(0,0,0,.25) 100%);position: absolute;
            top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;">
          <div style="width: 100%; position: absolute;height: auto;bottom: 0px;">
            <div class="md-title" style="font-size:24px; margin:10px; width:auto; text-align:center; color:white; font-weight:bold" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="margin:10px 20px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;" v-html="bio"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="altProfile == 29" class="noborder" style="align-items:center; width:100%'; display:grid !important; min-height:175px;margin-top:20px;"> 
      <!-- <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="width:80%; margin-right:auto; margin-left:auto;background: none;"> -->
        <img v-bind:src="getUserPicture" style="width:55%; object-fit: contain; object-position: center;margin-left:auto; margin-right:auto;-webkit-filter: drop-shadow(2px 2px 4px #222); filter: drop-shadow(2px 2px 4px #222); max-height:250px;" v-bind:style="userDetails.pictureStyling"  >
            <div class="md-title" v-if="userDetails.nameHide != true"  v-bind:style="[{color: textColour(userDetails.background)}, userDetails.profileStyling]" style="filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);font-size:24px; margin:10px; width:auto; text-align:center; color:white; font-weight:bold">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);margin:0 10px 10px 10px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:16px; white-space: pre-wrap;" v-bind:style="userDetails.profileStyling" v-html="bio"></div>

      <!-- </div> -->
      <!-- <div v-bind:style="{color:textColour(userDetails.background)}" style="padding-top:10px"> -->
        <!-- <div v-if="nameHide != true" class="md-title"  style="font-weight:bold;text-align:center;font-size:24px; " v-html="userDetails.name">{{ userDetails.name }}</div> -->
        <!-- <div v-if="bio" class="bio" style="text-align:center; font-size:16px; padding:10px 20px;"  v-html="bio"></div> -->
      <!-- </div> -->
      <div v-if="userDetails.business && userDetails.business.links" style="display: flex;justify-content: center;" v-bind:style="userDetails.profileStyling">
        <div v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="position:relative;display:flex;justify-content: center;padding-bottom:5px" v-bind:style="userDetails.profileStyling">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
          <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')" style="color:#ffffff">
            <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
            <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" v-bind:style="link.style"/>
          </md-button>

  </div>
  <!-- <md-button v-if="userDetails.business.download != false" :href="userDetails.business.linkFacebook" target="_blank" class="md-icon-button md-raised" @click="downloadvCard()">
  <md-icon style="color:#ffffff">person_add</md-icon>
</md-button> -->

<!-- <md-button v-if="userDetails.business.qrcode != false" class="md-icon-button md-raised" @click="openDialog('qrcodeDialog')">
    <md-icon style="color:#ffffff">qr_code</md-icon>
  </md-button> -->
  </div>
    </div>
    <div v-else-if="altProfile == 31" class="noborder" style="align-items:center; width:100%'; display:grid !important; min-height:175px;margin-top:15px; margin-bottom: 15px !important;"> 
      <!-- <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="width:80%; margin-right:auto; margin-left:auto;background: none;"> -->
        <img v-bind:src="userDetails.headerImage" v-bind:style="[userDetails.pictureStyling]" style="
    object-fit: contain;
    object-position: center;margin-left:auto; margin-right:auto;-webkit-filter: drop-shadow(2px 2px 4px #222);
  filter: drop-shadow(2px 2px 4px #222); 
    " >

          <img v-bind:src="getUserPicture" v-bind:style="{border: setAvatarBorder(userDetails.background)}" v-bind:class="{roundAvatar: userDetails.pictureShape == 'circle', squircle: userDetails.pictureShape == 'squircle', squareAvatar: userDetails.pictureShape == 'square'}" style="margin-top:10px; margin-bottom:10px;height:125px; width:125px; position:relative; display:block; margin-left:auto; margin-right:auto;" >


            <!-- <div style="overflow:hidden; height:175px; backdrop-filter:blur(10px);background: linear-gradient(180deg,hsla(0,0%,100%,0) 10%,rgba(0,0,0,.1));"> -->
        <!-- <div v-bind:class="{squircleContainer: userDetails.pictureShape == 'squircle'}" style="margin-top:15px; position: absolute;left: calc(50% - 54.5px);"> -->
        <!-- </div> -->
        <!-- <div v-if="nameHide != true" class="md-title"  style="text-align:center; color:white;font-size:24px; margin-top:130px; text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);">{{ userDetails.name }}</div> -->
      <!-- </div> -->

      <div class="md-title" v-if="userDetails.nameHide != true"  v-bind:style="[userDetails.profileStyling, {color: textColour(userDetails.background)}]" style="background-clip: text; filter: drop-shadow(rgb(0, 0, 0) 0px 0px 2px);font-size:24px; margin:10px; width:auto; text-align:center; color:white; font-weight:bold">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);margin:0 10px 10px 10px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:16px; white-space: pre-wrap;" v-bind:style="userDetails.profileStyling" v-html="bio"></div>

      <!-- </div> -->
      <!-- <div v-bind:style="{color:textColour(userDetails.background)}" style="padding-top:10px"> -->
        <!-- <div v-if="nameHide != true" class="md-title"  style="font-weight:bold;text-align:center;font-size:24px; " v-html="userDetails.name">{{ userDetails.name }}</div> -->
        <!-- <div v-if="bio" class="bio" style="text-align:center; font-size:16px; padding:10px 20px;"  v-html="bio"></div> -->
      <!-- </div> -->
      <div style="display: flex;
    justify-content: center;"><div v-if="userDetails.business && userDetails.business.links" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="position:relative;display:flex;justify-content: center;padding-bottom:5px">
  <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
  <md-button class="md-icon-button md-raised" @click="profileLinksClicked(index, link.target, 'custom')" style="color:#ffffff">
   <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
  <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
</md-button>

  </div>
  <md-button v-if="userDetails.business.download != false" :href="userDetails.business.linkFacebook" target="_blank" class="md-icon-button md-raised" @click="downloadvCard()">
  <md-icon style="color:#ffffff">person_add</md-icon>
</md-button>

<md-button class="md-icon-button md-raised" @click="openDialog('qrcodeDialog')">
    <md-icon style="color:#ffffff">qr_code</md-icon>
  </md-button>
  </div>
  
    </div>
    <div v-else-if="altProfile == 32" style="justify-content: center; display: grid; padding: 0 0 10px 0px;">
      <!-- <svg viewBox="0 0 56 18">
  <text x="0" y="15">Fit Me</text>
</svg> -->
<img v-bind:src="getUserPicture" style="width:100%" v-bind:style="[userDetails.pictureStyling]" />
        <div v-if="nameHide != true" class="md-title"  style="text-transform:uppercase; letter-spacing: 3px; text-align:center; font-weight:bold; font-size:24px; " v-html="userDetails.name"></div>
<div v-if="bio" class="bio18" style="font-size:16px; text-align:center; margin-top:10px;" v-html="bio"></div>
      <!-- <div v-if="bio" class="bio" v-bind:style="{color: textColour(userDetails.headerColor)}" style="width:100%; text-align:center" v-html="bio"></div> -->
    </div>
    <div v-else-if="(altProfile == 33 || altProfile == 34 || altProfile == 35 || altProfile == 36 || altProfile == 37)" disabled class="profileAlt2" style="padding:unset;margin-right:0px; margin-left:0px; display: block; width:100%;max-width:100%; overflow:hidden; position:relative">
      <div style="width:100%;" v-bind:class="{ aspectRatio1x1 : altProfile == 33, aspectRatio4x3: altProfile == 34, aspectRatio16x9: altProfile == 35, aspectRatio3x4: altProfile == 36, aspectRatio9x16: altProfile == 37}" v-bind:style="{'padding-top': profileHeaderPadding}">
        <img id="profilePicAlt2" alt="" v-bind:src=getUserPicture style="object-fit:cover; object-position:center;position: absolute;top: 0px;left: 0px;height:100%;width:100%" v-bind:style="userDetails.pictureStyling">
        <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="position: absolute;
            top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;">
          <div style="width: 100%; position: absolute;height: auto;bottom:0px;padding: 20px;" v-bind:style="userDetails.profileStyling">
            <div class="md-title" style="word-spacing: 100vw; width:auto; color:white; line-height:50px; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px); text-transform: capitalize;font-size:50px; font-weight:bolder" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);" v-html="bio"></div>
              <div v-if="userDetails.business != undefined" style="color:white;     display: flex; gap:12px; justify-content: space-between">
        <md-button v-for="(link, index) in userDetails.business.links" class="md-icon-button" v-bind:key="index" v-if="userDetails.business.links && link.enabled != false" style="margin:unset;  min-width:24px" v-bind:class="{profilepulse: link.pulse}" @click="profileLinksClicked(index, link.target, 'custom', link.label)">
  <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon" v-bind:style="link.style"></md-icon>
  <img v-else style="height:24px; width:24px; margin-bottom:5px;filter: drop-shadow(rgb(0, 0, 0) 0px 1px 0px);" :src="link.icon" />

</md-button></div>
          </div>
          
        </div>
        
      </div>
    </div>

    <div v-else-if="(altProfile == 38)" disabled>
      <div style="width:100%;" v-bind:style="{}">
        <img v-bind:src=getUserPicture style="max-height: 300px;object-fit:contain; object-position:center;height:100%;width:100%; filter:drop-shadow(#ffffff 0px 0px 4px)" v-bind:style="userDetails.pictureStyling">
        <!-- <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="position: absolute;top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;"> -->
          <div style="width: 100%;height: auto;bottom:0px;padding: 10px;text-align:center; margin-top: -30px;">
            <div v-if="userDetails.nameHide != true" class="md-title" style="width:auto; color:white; line-height:35px; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px); text-transform: capitalize;font-size:35px; font-weight:bolder" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);" v-html="bio"></div>
          </div>
        <!-- </div> -->
      </div>
      <div v-if="userDetails.business" style="display: flex;flex-flow: row; justify-content: center;padding-bottom:10px">
        <div v-if="userDetails.business.links && link.enabled != false" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="color:#ffffff;">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
            <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')">
              <md-icon v-if="link.fa" :md-iconset="'fa fa-fw fa-'+link.icon" ></md-icon>
              <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
            </md-button>
          </div>
        </div>
      </div>

      <div v-else-if="(altProfile == 39)" disabled>
      <div style="width:100%;" v-bind:style="{}">
        <img v-bind:src=getUserPicture style="max-height: 300px;object-fit:cover; object-position:center;height:100%;width:100%;" v-bind:style="userDetails.pictureStyling">
        <!-- <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="position: absolute;top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;"> -->
          <div v-if="userDetails.nameHide != true" style="width: 100%;height: auto;bottom:0px;padding: 10px;text-align:center; margin-top: -30px;">
            <div class="md-title" style="width:auto; color:white; line-height:35px; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px); text-transform: capitalize;font-size:35px; font-weight:bolder" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);" v-html="bio"></div>
          </div>
        <!-- </div> -->
      </div>
      <div v-if="userDetails.business" style="display: flex;flex-flow: row; justify-content: center;padding-bottom:10px">
        <div v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="color:#ffffff;">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
            <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')">
              <md-icon v-if="link.fa" :md-iconset="'fa fa-fw fa-'+link.icon" ></md-icon>
              <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
            </md-button>
          </div>
        </div>
      </div>
      <div v-else-if="(altProfile == 40)" disabled>
      <div style="width:100%;" v-bind:style="{}">
        <img v-bind:src=getUserPicture style="max-height: 300px;object-fit:contain; object-position:center;height:100%;width:100%;" v-bind:style="userDetails.pictureStyling">
        <!-- <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="position: absolute;top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;"> -->
          <div v-if="userDetails.nameHide != true" style="width: 100%;height: auto;bottom:0px;padding: 10px;text-align:center; margin-top: -30px;">
            <div class="md-title" style="width:auto; color:white; line-height:35px; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px); text-transform: capitalize;font-size:35px; font-weight:bolder" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);" v-html="bio"></div>
          </div>
        <!-- </div> -->
      </div>
      <div v-if="userDetails.business" style="display: flex;flex-flow: row; justify-content: center;padding-bottom:10px">
        <div v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="color:#ffffff;">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
            <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')">
              <md-icon v-if="link.fa" :md-iconset="'fa fa-fw fa-'+link.icon" ></md-icon>
              <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
            </md-button>
          </div>
        </div>
      </div>
      <div v-else-if="(altProfile == 41)" disabled>
      <div style="width:100%;" v-bind:style="{}">
        <img v-bind:src=getUserPicture style="max-height: 300px;object-fit:contain; object-position:center;height:100%;width:100%;" v-bind:style="userDetails.pictureStyling">
        <!-- <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="position: absolute;top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;"> -->
          <div v-if="userDetails.nameHide != true" style="display:flex; flex-flow:column; gap:10px;border-radius:10px; border:2px solid white;  width: 100%;height: auto;bottom:0px;padding: 10px;text-align:center; margin-top: -30px;" v-bind:style="{background: userDetails.headerColor}">
            <div class="md-title" style="width:auto; color:white; line-height:35px; filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px); text-transform: capitalize;font-size:35px; font-weight:bolder" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
            <div v-if="bio && bio != '<blank>'" style="line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);" v-html="bio"></div>
              <div v-if="userDetails.business" style="display: flex;flex-flow: row; justify-content: center;padding-bottom:0px">
        <div v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="color:#ffffff;">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
            <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')">
              <md-icon v-if="link.fa" :md-iconset="'fa fa-fw fa-'+link.icon" ></md-icon>
              <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
            </md-button>
          </div>
        </div>
          </div>
        <!-- </div> -->
        
      </div>
      
      </div>
      <div v-else-if="(altProfile == 42)" disabled>
      <div style="width:100%;aspect-ratio:16/9;position:relative;overflow:hidden" v-bind:style="{'background':userDetails.headerColor}">
        <img v-bind:src=getUserPicture style="margin-left:10%; padding-top:20px;aspect-ratio:1/1; object-fit:contain; object-position:right bottom;height:100%;width:100%;" v-bind:style="userDetails.pictureStyling">

        <!-- <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="position: absolute;top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;"> -->
          <div v-if="userDetails.nameHide != true" style="margin-left:10px; position:absolute; width: 100%;max-width:60%;height: auto;bottom:0px;padding: 10px;" v-bind:style="{'color': textColour(userDetails.headerColor)}">
            <div class="md-title" style="word-spacing: 100vw; font-size:2.5rem; line-height: 2.6rem;
    margin-bottom: 10px; width:auto; text-transform: uppercase;display: flex; flex-flow: column;" v-bind:style="userDetails.profileStyling">
    <span v-for="(word, index) in splitTitle(userDetails.name)" :key="index" v-bind:class="{'boldTitle': index== 0}">{{ word }} </span></div>
            <div v-if="bio && bio != '<blank>'" style="line-height:initial;font-weight:normal; font-size:small; white-space: pre-wrap;" v-html="bio"></div>
              <div v-if="userDetails.business" style="display: flex;flex-flow: row; gap:15px;justify-content: start;padding-top:4px; padding-bottom:0px">
        <div v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" v-bind:key="index" style="color:#ffffff;">
          <div v-if="usage == 'admin' && link.clicks != null" class="counter">{{link.clicks}}</div>
            <md-button class="md-icon-button" v-bind:class="{profilepulse: link.pulse}" style="border-radius: unset; padding:unset; min-width:24px; width:24px; margin:unset" v-bind:style="link.style" @click="profileLinksClicked(index, link.target, 'custom')">
              <md-icon v-if="link.fa" :md-iconset="'fa fa-fw fa-'+link.icon" style="margin:unset" v-bind:style="{'color': textColour(userDetails.headerColor)}"></md-icon>
              <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
            </md-button>
          </div>
        </div>
          </div>

        <!-- </div> -->
        
      </div>
      
      </div>

      <div v-else-if="altProfile == 43" class="noborder" style="align-items:center; width:100%'; display:grid !important; "> 
        <img v-bind:src="getUserPicture" style="object-fit: contain; object-position: center; margin-left:auto; margin-right:auto;-webkit-filter: drop-shadow(2px 2px 4px #222); filter: drop-shadow(2px 2px 4px #222); max-height:200px;" v-bind:style="userDetails.pictureStyling"  >
      </div>
      <div v-else-if="altProfile == 44" class="noborder" style="align-items:center; max-height:125px; padding:10px;width:100%'; display:flex !important;flex-flow:column; justify-content:center;align-items:center; width:100%;" v-bind:style="{background: userDetails.headerColor}"> 
        <img v-bind:src="getUserPicture" style="object-fit: contain; object-position: center;padding:10px;max-height:50px;" v-bind:style="userDetails.pictureStyling"  >
        <div v-if="userDetails.business != undefined" style="justify-content: center; display: flex;">
                  <md-button v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" :href="link.target" v-bind:key="index" target="_blank" class="md-icon-button" style="color:#ffffff; border-radius:5px">
                    <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
                    <img v-else style="height:18px; width:18px; margin-bottom:5px;" :src="link.icon" />
                  </md-button>
                </div>
      </div>



      
      <div v-else-if="(altProfile == 2000 || altProfile == 2001 || altProfile == 2002 || altProfile == 2003 || altProfile == 2004)" disabled class="profileAlt2" style="padding:unset;margin-right:0px; margin-left:0px; display: block; width:100%;max-width:100%; overflow:hidden; position:relative">
        <div style="width:100%;" v-bind:class="{ aspectRatio1x1 : altProfile == 2000, aspectRatio4x3: altProfile == 3, aspectRatio16x9: altProfile == 11, aspectRatio3x4: altProfile == 9, aspectRatio9x16: altProfile == 19}" v-bind:style="{'padding-top': profileHeaderPadding}">
          <img id="profilePicAlt2" alt="" v-bind:src=getUserPicture style="object-fit:cover; object-position:center;position: absolute;top: 0px;left: 0px;height:100%;width:100%" v-bind:style="[userDetails.pictureStyling]">
          <div  v-if="nameHide != true" id="gradientBackgroundforProfilePic" style="background: rgb(255,255,255);
              background: linear-gradient(180deg, rgba(255,255,255,0) 50%, rgba(0,0,0,.25) 100%);position: absolute;
              top: 0px; left: 0px; height: 100%; width: 100%;border-radius: 20px 20px 0px 0px;">
            <div style="width: 100%; position: absolute;height: auto;bottom: 0px;">
              <div class="md-title" style="font-size:24px; margin:10px; width:auto; text-align:center; color:white; font-weight:bold" v-bind:style="userDetails.profileStyling">{{ userDetails.name }}</div>
              <div v-if="bio && bio != '<blank>'" style="margin:10px 20px 0 20px;text-align:center;line-height:initial;color:white;font-weight:normal; font-size:small; white-space: pre-wrap;" v-html="bio"></div>
                <div v-if="userDetails.business != undefined" style="justify-content: center; display: flex;">
                  <md-button v-if="userDetails.business.links" v-for="(link, index) in userDetails.business.links" :href="link.target" v-bind:key="index" target="_blank" class="md-icon-button" style="color:#ffffff; border-radius:5px">
                    <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon>
                    <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" />
                  </md-button>
                </div>
                <div v-if="userDetails.changeOnline" style="padding:0 5px; display:grid;grid-template-columns: 1fr 1fr 1fr; gap:5px" class="changeOnline">
                  <md-button v-if="userDetails.changeOnline.profileButton" v-for="(link, index) in userDetails.changeOnline.profileButton" v-bind:key="index" class="" style="font-size:small; line-height:18px; white-space:normal; margin-left:unset; margin-right:unset; color:#ffffff; border-radius:7.5px;backdrop-filter: blur(5px);
    border: 1px rgba(255,255,255,0.25) solid;" v-html="link.label" @click="openProfileVideo(link.label, link.source)">
                    <!-- <md-icon v-if="link.fa" :md-iconset="'fa fa-'+link.icon"></md-icon> -->
                    <!-- <img v-else style="height:18px; width:18px; margin-bottom:5px" :src="link.icon" /> -->
                    <!-- {{ link.label }} -->
                  </md-button>

                </div>
              </div>
          </div>
        </div>
      </div>
      <div v-else-if="(altProfile == 3000)">
        <img v-bind:src=getUserPicture style="width:100%; aspect-ratio:1/1; object-fit:cover;">
        videobot dupe
      </div>


      


    



<svg width="0" height="0" style="position:fixed; border:0px solid black">
  <defs>
    <clipPath id="squircle" clipPathUnits="objectBoundingBox">
      <path d="M .5,0 C .1,0 0,.1 0,.5 0,.9 .1,1 .5,1 .9,1 1,.9 1,.5 1,.1 .9,0 .5,0 Z"></path>
    </clipPath>
  </defs>
</svg>
<!-- <img v-bind:src="getUserPicture" v-bind:class="{squircleIOS: userDetails.pictureShape == 'squircle'}" style="border:1px dashed black" > -->

<md-dialog ref="changeVideo">
  <md-dialog-title style="text-transform:uppercase; font-size:18px;margin-bottom:unset;padding:10px 10px 0 10px; text-align:center">{{videoTitle}}</md-dialog-title>

  <md-dialog-content style="aspect-ratio: 9 / 16;
    border-radius: 15px;
    margin: 10px;
    padding: 0;" v-html="videoSource">
    <!-- <iframe :src="videoSource" style="border-radius:15px; aspect-ratio: 346/615; " allow="autoplay"></iframe> -->

    <!-- <iframe width="346" height="615" src="" title="Magician tries to sell weed to cops #PRANK #shorts" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
    <!-- <video width="320" height="240" controls>
  <source :src="videoSource">
  Your browser does not support the video tag.
</video> -->
  <!-- <div style="width:100%; height:100%; border:1px solid silver; border-radius:15px;"> -->

  <!-- </div> -->
  <!-- <div></div> -->
  </md-dialog-content>

  <!-- <md-dialog-actions>
    <md-button class="md-primary" @click="closeDialog('changeVideo')">Close</md-button>
  </md-dialog-actions> -->
</md-dialog>


<md-snackbar id="snackbar" ref="snackbar" class="verified" :md-duration="Infinity">
  <h3 style="display:flex">Verified Slink Page<span style="flex: 1"/><md-icon style="margin-right:5px; color:rgb(56, 151, 240)">verified</md-icon></h3>
  <div>The owner of this Slink page has been verified using official government-issued identification documents to confirm their identity.</div>
    <!-- <div>
      <div style="font-weight:bold"><md-icon style="margin-right:5px">verified</md-icon>Verified Profile</div>
      <div style="margin-top:5px; margin-left:29px">This user's ID has been verified.</div>
      <div style="margin-left:29px">All links and content displayed here are genuine.</div>
      <div style="margin-left:29px">No fakes allowed here!</div>
    </div> -->
    <md-button class="md-raised rounded5 md-dense" @click="$refs.snackbar.close()" style="width: 100%;
    margin: unset;
    margin-top: 5px;">OK</md-button>
  </md-snackbar>
  <!-- TOAST NOTIFICATION END -->
<md-dialog-alert :md-title="qrcode.title" :md-content-html="qrcode.contentHtml" ref="qrcodeDialog" class="qrDialog">
</md-dialog-alert>



  </div>
            
</template>

// Our functional scripts will go here
<script>
 import {fb} from './firebaseconfig'
import { analytics } from "./firebaseconfig";

let db = fb.database();

export default {
  

    props:{
        userDetails: {
          type: [Array, Object],
        },
        usage: String,
        altProfile: Number,
        picture: String,
        background: String,
        bio: String,
        account: Number,
        nameHide: Boolean,
        enableUpgrades: Boolean,
        uid: String,
        },

  data() {
    return {
    //   status: false,
    videoTitle: null,
    videoSource: null,
    qrcode: {
          title: 'Slink QR Code',
          contentHtml: 'qrcode'
        },
    };
  },
  computed:{
    profileHeaderPadding: function(){
      try{
        if(this.altProfile == 3 || this.altProfile == 4 || this.altProfile == 34){
          return '75%'
        }
        else if(this.altProfile == 11 || this.altProfile == 35){
          return '56.25%'
        }
        else if(this.altProfile == 9 ){
          return '133%'
        }
        else if(this.altProfile == 12 ){
          // return '33.33%'
          return '56.25%'
        }
        
        else{
          return '100%'
        }
      }
      catch (e){}
    },
    getRandomPicture: function(){
      let randBoolean = Math.random() < 0.5;
      return randBoolean ? this.picture : this.userDetails.pictureAlt

    },
    // getUserPicture: function() {
    //   if (this.picture) {
    //     if(this.userDetails.pictureSize){
    //       let imageKit = this.picture
    //       imageKit =imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-profilepicture')
    //       imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-profilepicture')
    //       return imageKit
    //     }
    //     else if(this.userDetails.pictureAdult){
    //       let imageKit = this.picture
    //       imageKit =imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-blur')
    //       imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-blur')
    //       return imageKit
    //     }
    //     else{
    //       return this.picture;
    //     }
    //   } 
    //   else {
    //     return (
    //       "https://ui-avatars.com/api/?color=fff&background=3f51b5&size=128&name=" + this.userDetails.name.substring(0, 1)
    //     );
    //   }
    // },
    getUserPicture: function() {  //updated 2020-11-20
      const { picture, userDetails } = this;
      if (picture) {
        let imageKit = picture;
        if (userDetails.pictureSize) {
          imageKit = imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-profilepicture')
          imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-profilepicture')
        } else if (userDetails.pictureAdult) {
          imageKit = imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-blur')
          imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-blur')
        }
        return imageKit;
      } 
      return (
        "/static/images/avatar.jpg"
      );
    },
  },
  methods:{
  splitTitle(username){
      // Split the original text into words
      return username.split(/\s+/);
  },
    openProfileVideo(title, video){
      console.log('openProfileVideo', title, video)
      this.videoTitle = title
      this.videoSource = video
      this.$refs['changeVideo'].open();
    },
    openDialog(ref) {
      this.qrcode.contentHtml = '<div style="width:100%; text-align:center;"><h1>'+ this.userDetails.name+'</h1><img src="https://chart.apis.google.com/chart?cht=qr&chs=300x300&chld=H|0&chl=https://www.myslink.app/'+ this.userDetails.url +'" style="max-width: 275px; width: 90%; padding: 10px; background: white; border-radius: 20px;"><p style="padding-top:20px"><a href="https://myslink.app/' + this.userDetails.url + '" style="color:black" target="_blank">myslink.app/' + this.userDetails.url + '</a></div>'
      this.$refs[ref].open();
    },
    profileLinksClicked: function(linkUID, link, type, label){
      if(this.usage !== 'admin'){
        var path = null
        if(type !== 'custom'){
          path = 'users/'+ this.uid +'/business/'+ type +'Clicks'
        }
        else{
          path = 'users/'+ this.uid +'/business/links/'+ linkUID +'/clicks'
        }
        console.log( 'profileLinksClicked', this.uid, link, type, label)
        window.open(link);
        var updateClicksRef =  db.ref(path);
        updateClicksRef.transaction(function (current_value) {
          return (current_value || 0) + 1;
        });
        let gaLabel = label == null ? link : label
        analytics.logEvent("link_click", {'site': 'Profile Link', 'link': gaLabel});
      }
    },
    // isAltProfileAllowed:function(requirement){ //redundant
    //   let profile = null
    //   if(this.userDetails.account >= requirement){
    //     profile = this.altProfile
    //   }
    //   else{
    //     profile = 0
    //   }
    //   return profile
    // },
    getClearContainer: function(){
      if(this.userDetails.pictureShape != 'squircle'){
        return 'unset !important'
      }
      else{
        return this.textColour(this.userDetails.headerColor) + ' !important'
      }
    },
    // getEntitlement: function(reqLevel){  //redudant
    //   if(this.account != reqLevel || !this.enableUpgrades){
    //     return false
    //   }
    //   else{
    //     return true
    //   }
    // },
    setAvatarBorder: function(bg) {
      if(this.userDetails.pictureShape != 'squircle'){
        return this.account == 7 ? "2px solid " + bg : "2px solid #ffffff";
      }
      else if(this.userDetails.pictureShape == 'squircle'){
        return this.account == 7 ? bg : "#ffffff"; 
      }
    },
    textColour: function(bg) {
      if(this.userDetails.headerFontColor){
        return this.userDetails.headerFontColor
      }
      else{
        if (bg == undefined){
          bg = '#ffffff'
        }
      var r = parseInt(bg.substr(1,2), 16); // Grab the hex representation of red (chars 1-2) and convert to decimal (base 10).
      var g = parseInt(bg.substr(3,2), 16);
      var b = parseInt(bg.substr(5,2), 16);
      r /= 255, g /= 255, b /= 255;
      var max = Math.max(r, g, b), min = Math.min(r, g, b);
      var l = (max + min) / 2;
      return "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)"

      }
      
    },
    downloadvCard: function(){
         console.log('download vCard')
         let imageURL = this.userDetails.picture.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-vcf')
         fetch(imageURL)
        .then(response => response.blob())
        .then(blob => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result.split(',')[1]);
                };
                reader.readAsDataURL(blob);
            });
        })
        .then(imageBase64 => {
            let vcard = 'BEGIN:VCARD' + '\n';
            vcard += 'VERSION:3.0' + '\n';
            vcard += 'N;CHARSET=utf-8:;' + this.userDetails.name + ';;;;' + '\n'
            vcard += 'FN;CHARSET=utf-8:' + '\n'
            vcard += 'PHOTO;ENCODING=b;TYPE=image/png:' + imageBase64 + '\n';
            if (this.userDetails.altProfile == 20) {
                vcard += 'ORG:' + this.userDetails.business.company + '\n';
                vcard += 'TITLE:' + this.userDetails.business.title + '\n';
                vcard += 'EMAIL;TYPE=PREF,INTERNET:' + this.userDetails.business.email + '\n';
                vcard += 'TEL;TYPE=WORK,voice:' + this.userDetails.business.phone + '\n';
                vcard += 'URL:' + this.userDetails.business.linkHome + '\n';
            }
            vcard += 'item1.URL;type=pref:https://www.myslink.app/' + this.userDetails.url + '\n';
            vcard += 'item1.X-ABLabel:Slink Digital Business Card\n';
            vcard += 'END:VCARD';
            const blob = new Blob([vcard], { type: 'text/vcard' });
            const filename = this.userDetails.name + '.vcf';
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
        .catch(error => {
            console.error('Error fetching or encoding image:', error);
        });
      },
  },
  beforeCreate () {
    // let self = this 
  //  console.log('profileheader beforeCreated', self.userDetails)
  },
  created () {
    // console.log('profileheader', this.userDetails)
  },
}
</script>

// Our styling will go here
<style>

.boldTitle{
  font-weight:bolder;
}

.profileAlt2 .md-list-item-container{
  padding:unset !important
}

.md-snackbar.verified{
  border-radius:10px 10px 0 0;
  overflow:hidden;
  z-index: 999; 
}

.md-snackbar.verified .md-snackbar-container .md-snackbar-content{
align-items: unset;
flex-flow: column;
gap:5px;
}

.md-theme-default.md-dialog-container .md-dialog {
  border-radius: 20px;
}

</style>
<style scoped>


.counter{
  position: absolute;
    border-radius: 4px;
    background: white;
    padding: 0px 4px;
    right: -5px;
    top: -7px;
    font-weight: bold;
    font-size: small;
    max-height: 20px;
    border: 1px solid silver;
    z-index: 1;
    line-height: initial;}

/* .ar9x16{
  aspect-ratio: 9/16;
} */

/* .ar3x4{
  aspect-ratio: 3/4;
} */

/* .ar1x1{
  aspect-ratio: 1/1;
} */


.aspectRatio1x1{
  aspect-ratio: 1/1
}

.aspectRatio4x3{
  aspect-ratio: 4/3
}

.aspectRatio16x9{
  aspect-ratio: 16/9
}

.aspectRatio3x4{
  aspect-ratio: 3/4
}

.aspectRatio9x16{
  aspect-ratio: 9/16
}

.compactLinkMargin{
    /* margin-right:unset !important; */
    padding-top:12px !important;
}

.squircleContainer{
background: white !important;
    padding: 2px;
    /* clip-path: url(#squircle) !important; */
    /* -webkit-clip-path: url(#squircle);
     */
  -webkit-clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);
  clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);

    width: 109px;
    margin: 0 auto auto auto;
}

.squircle {
  /* -webkit-clip-path:url(#squircle); */
  -webkit-clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);
  /* clip-path:url(#squircle); */
  clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);

  object-position: center;
  object-fit: cover;
  border-style:unset !important;
  aspect-ratio: 1/1;
}

.altProfile0IOS{
display: grid;
justify-content: center;
}

.squircleIOS {
  /* -webkit-clip-path:url(#squircle); */
  /* clip-path:url(#squircle); */
  clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);
  width:105px !important;
  height:105px !important;
  object-position: center;
  object-fit: cover;
  position:relative;
  /* border-style:unset !important; */
  /* aspect-ratio: 1/1; */
}
 .clearContainer{
   background: unset !important
 }
.avatar2x{
  width: 210px !important;
}

.roundAvatar {
  aspect-ratio:1/1;
  border-radius: 100%;
  object-position: center;
  object-fit: cover;
}

.businessProfile .squareAvatar{
  width:100px;
  height:100px; 
  aspect-ratio: 1/1;
  border-radius: 10px !important;
  object-position: center;
  object-fit: cover;
}

.squareAvatar {
  aspect-ratio: 1/1;
  border-radius: 10px;
  object-position: center;
  object-fit: cover;
}

.roundAvatar.altProfile1avatar{
  width:80px;
  height:80px;
  min-width:80px; min-height:80px
}

.altProfile1, .altProfile6{
  padding:20px 16px;
  min-height:120px;
  display: grid;
  gap:10px;
  max-width: -webkit-fill-available;
}

.altProfile1{
  grid-template-columns: 84px calc(100% - 94px);
}

.altProfile6{
  grid-template-columns: calc(100% - 94px) 84px;
}

.altProfile1 .squircleContainer, .altProfile6 .squircleContainer{
  width:unset;
}

.altProfile1 .name, .altProfile6 .name{
  text-transform:uppercase;
  font-weight:bold;
  font-size:large;
  word-break: break-word;
}

.textbox{
  margin-top: auto;
  margin-bottom: auto;
}

.businessProfile{
  padding-bottom:10px
}

.businessProfile .info .businessLinks .md-button{
  width: 36px;
  min-width: 36px;
  height: 36px;
  min-height: 36px;
  border-radius: 7px;
  margin: 0px 0px;
}

.businessProfile .info .businessLinks .md-button i{
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
  font-size: 18px;vertical-align: text-bottom;
}

.noLogo{
  padding:16px !important;
}

/* .adultPicture img{ */
  /* image-rendering: pixelated; */
  /* -webkit-filter: blur(10px); */
    /* filter: blur(10px); */
/* } */

.shake{
  animation: shake 2.0s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.profilepulse {
  /* margin:100px; */
  /* display: block; */
  /* width: 22px; */
  /* height: 22px; */
  border-radius: 50%;
  /* background: red; */
  cursor: pointer;
  box-shadow: 0 0 0 rgba(204,169,44, 0.4);
  animation: profilepulse 2s infinite;

}
.profilepulse:hover {
  animation: none;
}

@-webkit-keyframes profilepulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255,255,255, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(255,255,255, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(255,255,255, 0);
  }
}
@keyframes profilepulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255,255,255, 0.4);
    box-shadow: 0 0 0 0 rgba(255,255,255, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(255,255,255, 0);
      box-shadow: 0 0 0 10px rgba(255,255,255, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(255,255,255, 0);
      box-shadow: 0 0 0 0 rgba(255,255,255, 0);
  }
}


</style>


// WEBPACK FOOTER //
// src/components/profileheader_component.vue